import { SunCenterPrintingService } from './sun-center-printing.service';
import { Injectable } from '@angular/core';

@Injectable()
export class SunCenterPrintingBrowserService implements SunCenterPrintingService {
    public async print(blob: Blob): Promise<void> {
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        const printObjectUrl = URL.createObjectURL(pdfBlob);

        const printJsModule = await import('print-js');
        const printJS = printJsModule.default as (url: string) => void;
        printJS(printObjectUrl);
    }
}
